// Redux Actions Types
import { SET_WIDGET_FILTES, SELECT_WIDGET_FILTES } from './types';

export const setWidgetFilters = payload => ({
  type: SET_WIDGET_FILTES,
  payload
});

export const selectWidgetFilters = payload => ({
  type: SELECT_WIDGET_FILTES,
  payload
});
